import React, { memo } from "react";
import { Modal, Button } from "react-bootstrap";

const SaveAndExitPopup = memo( function SaveAndExitPopup({
	isOpen, handler, saveTestAndExit
}) {

	const toggle = () => {
		handler(prev => false);
	};

	const submitAndShowNext = () => {
		saveTestAndExit();
		toggle();
	};

	return (
		// <Modal show={isOpen} size="sm">
		// 	<Modal.Body>
		// 		<div>Do you want to save and exit mock test?</div>
		// 	</Modal.Body>

		// 	<Modal.Footer>
		// 		<Button
		// 			variant="secondary"
		// 			className="modalCloseBtn"
		// 			onClick={submitAndShowNext}
		// 		>Yes</Button>
				
		// 		<Button
		// 			variant="secondary"
		// 			className="modalCloseBtn"
		// 			onClick={toggle}
		// 		>No</Button>
		// 	</Modal.Footer>
		// </Modal>
	<Modal
	  show={isOpen}
	  size="md"
	  centered
	  contentClassName="mock-container"
	>
	  <Modal.Header style={{ padding: "0px" }} className="mock-popup-header">
		<div className="d-flex justify-content-end align-items-center p-2">
		  <button onClick={toggle} className="modal-close-btn">
			×
		  </button>
		</div>
	  </Modal.Header>
	  <Modal.Body>
		<div className="d-flex gap-2 align-items-center mock-resource-text">
		  Do you want to save and exit mock test?
		</div>
	  </Modal.Body>
	  <Modal.Footer>
		<Button
		  variant="secondary"
		  className="mock-test-modal-button"
		  onClick={submitAndShowNext}
		>
		  Yes
		</Button>
		<Button
		  variant="secondary"
		  className="mock-test-modal-button"
		  onClick={toggle}
		>
		  No
		</Button>
	  </Modal.Footer>
	</Modal>		
	);
});

export default SaveAndExitPopup;